function Accommodation_Section6() {
  return <></>;
}

export default Accommodation_Section6;
